import { render, staticRenderFns } from "./payrollDetails.vue?vue&type=template&id=2d027460&scoped=true"
import script from "./payrollDetails.vue?vue&type=script&lang=js"
export * from "./payrollDetails.vue?vue&type=script&lang=js"
import style0 from "./payrollDetails.vue?vue&type=style&index=0&id=2d027460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d027460",
  null
  
)

export default component.exports